import React, { useState } from "react";
import useTitanApp from "../../hooks/useTitanApp";
import { Modal, Box, Checkbox } from "@mui/material";
import { CiLocationOn } from "react-icons/ci";
import { IoPersonOutline } from "react-icons/io5";
import { MdOutlinePayment } from "react-icons/md";
import { LuSyringe } from "react-icons/lu";
import { MdOutlineContactPage } from "react-icons/md";
import { TbMedicineSyrup } from "react-icons/tb";
import { LiaHandshakeSolid } from "react-icons/lia";
import { CiCalendar } from "react-icons/ci";
import {
  MdOutlineEmail,
  MdOutlinePrint,
  MdOutlinePictureAsPdf,
  MdOutlineAttachMoney,
  MdOutlineReceiptLong,
} from "react-icons/md";

const TakePaymentModal = ({ show, handleClose }) => {
  const { appState, patientState } = useTitanApp();
  const { darkMode, currentPharmacy } = appState || {};
  const { selectedPatient, selectedPatientDetails } = patientState || {};
  const [selectedOptions, setSelectedOptions] = useState(["send_link"]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
  };

  const options = [
    {
      id: "send_link",
      name: "Send payment link to email",
      icon: MdOutlineEmail,
    },
    {
      id: "send_receipt",
      name: "Send receipt to email",
      icon: MdOutlineReceiptLong,
    },
    {
      id: "paid_cash",
      name: "Received payment in cash",
      icon: LiaHandshakeSolid,
    },
    { id: "export_pdf", name: "Export as PDF", icon: MdOutlinePictureAsPdf },
    { id: "print", name: "Print", icon: MdOutlinePrint },
  ];

  const handleOptionChange = (id) => {
    setSelectedOptions((prev) =>
      prev.includes(id) ? prev.filter((opt) => opt !== id) : [...prev, id]
    );
  };

  const getOptionBackground = (isSelected, mode) => {
    if (!isSelected) return "transparent";
    return mode ? "#111" : "#f2f2f2";
  };
  const handleRemoveClick = () => {
    handleClose();
  };

  return (
    <Modal open={show}>
      <Box sx={style}>
        <div className="take_payment_modal_wrapper">
          <div className="add_prescription_modal_header">
            <div className="d-flex">
              <h3>Take a payment</h3>
            </div>
            <button
              onClick={handleClose}
              style={{ color: darkMode ? "#f2f2f2" : "#222" }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icons-color"
                />
              </svg>
            </button>
          </div>
          <div className="prescription-fields-wrapper">
            <div className="payment-summary">
              <div className="left-panel">
                <h2>Payment</h2>
                <div className="section">
                  <h2>{currentPharmacy?.teamPharmacyName}</h2>
                  <div className="time-content">
                    <CiCalendar size={20} color={darkMode ? "#fff" : "111"} />
                    <p className="time">
                      Fri 11 February • 11:00am - 12:00pm (1h)
                    </p>
                  </div>
                  <p className="address_section">
                    <CiLocationOn size={20} color={darkMode ? "#fff" : "111"} />
                    <p>
                      {currentPharmacy?.teamPharmacyAddress}, United Kingdom
                    </p>
                  </p>
                </div>
                <hr></hr>
                <div className="section">
                  <h4>Customer Details</h4>
                  <p>
                    <IoPersonOutline size={20} />
                    <div>
                      <strong>{selectedPatient}</strong> •
                      {new Date(selectedPatientDetails?.dob).toLocaleDateString(
                        "en-GB"
                      ) || "-"}
                    </div>
                  </p>
                  <div className="total-payable">
                    <div className="total_section">
                      <MdOutlinePayment
                        size={20}
                        color={darkMode ? "#fff" : "111"}
                      />
                      <strong>Total Payable:</strong>
                    </div>
                    <span>£76.98</span>
                  </div>
                </div>
                <hr></hr>
                <div className="section">
                  <h4>Item Details</h4>
                  <ul className="item-list">
                    <li>
                      {" "}
                      <p>
                        <LuSyringe size={20} /> Yellow Fever Vaccine{" "}
                      </p>{" "}
                      <span>£34.98</span>
                    </li>
                    <li>
                      {" "}
                      <p>
                        {" "}
                        <MdOutlineContactPage size={20} /> Yellow Fever Vaccine
                        Certificate{" "}
                      </p>{" "}
                      <span className="free">FREE</span>
                    </li>
                    <li>
                      {" "}
                      <p>
                        {" "}
                        <LuSyringe size={20} /> Hepatitis A Vaccine{" "}
                      </p>{" "}
                      <span>£34.98</span>
                    </li>
                    <li>
                      {" "}
                      <p>
                        {" "}
                        <LuSyringe size={20} /> Typhoid Vaccine{" "}
                      </p>{" "}
                      <span>£34.98</span>
                    </li>
                    <li>
                      {" "}
                      <p>
                        {" "}
                        <TbMedicineSyrup size={20} /> 1x Pack of 14 Imodium
                        tablets{" "}
                      </p>{" "}
                      <span>£7.99</span>
                    </li>
                    <li>
                      {" "}
                      <p>Deposit</p> <span>- £19.99</span>
                    </li>
                  </ul>
                  <div className="grand-total">
                    Grand Total: <span>£76.98</span>
                  </div>
                </div>
                <button className="pos-button">
                  <span></span>
                  <span>POS System</span>
                  <span>→</span>
                </button>
              </div>
              <div className="right-panel">
                <h4>Additional</h4>
                <>
                  {options?.map((service) => {
                    const isSelected = selectedOptions.includes(service.id);
                    const Icon = service.icon; // get the component
                    return (
                      <Box
                        className="option"
                        key={service.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        onClick={() => handleOptionChange(service.id)}
                        sx={{
                          padding: "8px 12px",
                          borderRadius: "10px",
                          cursor: "pointer",
                          userSelect: "none",
                          backgroundColor: getOptionBackground(
                            isSelected,
                            darkMode
                          ),
                          "&:hover": {
                            backgroundColor: darkMode ? "#111" : "#f2f2f2",
                          },
                          mb: 1,
                          transition: "background-color 0.2s",
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <Icon size={18} color={darkMode ? "#fff" : "111"} />
                          <span>{service.name}</span>
                        </Box>
                        <Checkbox
                          checked={isSelected}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOptionChange(service.id);
                          }}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: darkMode ? "#fff" : "#000",
                              borderRadius: "50%",
                            },
                          }}
                        />
                      </Box>
                    );
                  })}
                </>
                <div className="buttons">
                  <button className="cancel" onClick={handleRemoveClick}>
                    Cancel
                  </button>
                  <button className="done">Done</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default TakePaymentModal;
